<template>
  <div class="PaginatedProducts">
    <div class="products">
      <ProductCard v-for="product, index in selectedProducts"
        v-show="productIsOnCurrentPage(index)"
        :key="product._id"
        :content="product"
        :defaultImage="defaultImage"
      />
    </div>
    <PaginationControls v-if="totalPages > 1"
      v-bind="{ currentPageNo, totalPages, selectPage }"
      class="paginationControls"
    />
  </div>
</template>

<script>
import PaginationControls from './PaginationControls.vue'
import ProductCard from './ProductCard.vue'

const itemsPerPage = 12

export default {
  components: {
    PaginationControls,
    ProductCard,
  },
  props: {
    products: {
      type: Array,
      default: () => [],
    },
    selectedCategory: {
      type: String,
      default: '',
    },
    defaultImage: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      currentPageNo: 0,
    }
  },
  computed: {
    selectedProducts() {
      if (this.selectedCategory) {
        return this.products.filter((product) => product.category === this.selectedCategory)
      }
      return this.products
    },
    totalPages() {
      return Math.ceil(this.selectedProducts.length / itemsPerPage)
    },
  },
  methods: {
    selectPage(pageNo) {
      this.currentPageNo = pageNo
      this.$el.scrollIntoView()
    },
    productIsOnCurrentPage(productIndex) {
      const productPageNo = Math.floor(productIndex / itemsPerPage)
      return productPageNo === this.currentPageNo
    }
  },
  watch: {
    products() {
      // Reset to first page when product set changes
      this.currentPageNo = 0
    },
  },
}
</script>

<style scoped>

.products {
  display: grid;
  gap: var(--spacing-7) var(--spacing-5);
}

.products + .paginationControls {
  margin-top: var(--spacing-12);
}

@media (--screen-md) {
  .products {
    grid-template-columns: repeat(2, 1fr)
  }
}

@media (--screen-lg) {
  .products {
    grid-template-columns: repeat(3, 1fr)
  }
}
</style>
